import { useSchemaContext } from "hooks-for/reskin/use-schema-context";
import { NamedExoticComponent } from "react";

type ExpectedType = { children: React.ReactNode };
export const ReskinWrapper = <V1Props extends ExpectedType, V2Props extends ExpectedType>({
    children,
    V1Wrapper,
    V2Wrapper,
    V1WrapperProps,
    V2WrapperProps,
}: {
    children: React.ReactNode;
    V1Wrapper: NamedExoticComponent<V1Props> | React.ElementType;
    V1WrapperProps?: Omit<V1Props, "children">;
    V2Wrapper: NamedExoticComponent<V2Props> | React.ElementType;
    V2WrapperProps?: Omit<V2Props, "children">;
}) => {
    const { isV1 } = useSchemaContext();
    const WrapperToUse = isV1 ? V1Wrapper : V2Wrapper;
    const { key, ...propsToUse } = (isV1 ? V1WrapperProps : V2WrapperProps) ?? ({} as any);

    return (
        <WrapperToUse key={key} {...(propsToUse as any)}>
            {children}
        </WrapperToUse>
    );
};
